import { assert } from '@txt/core.utils/assert';
import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';

type LinkContextValue = { Link: typeof Link; NavLink: typeof NavLink };

const LinkContext = React.createContext<LinkContextValue | null>(null);

export const TaxonomyLinkProvider: React.FC<LinkContextValue & { children: React.ReactNode }> = ({
  children,
  ...rest
}) => <LinkContext.Provider value={rest}>{children}</LinkContext.Provider>;

export const useLinkContext = () => {
  const context = React.useContext(LinkContext);
  assert(context, 'LinkContext not found');
  return context;
};
